"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentResult = void 0;
const react_1 = __importDefault(require("react"));
const payment_success_svg_1 = __importDefault(require("./assets/images/payment-success.svg"));
const payment_error_svg_1 = __importDefault(require("./assets/images/payment-error.svg"));
require("./payment-result.css");
const lang = __importStar(require("./lang.json"));
/**
 * Main component.
 * @name PaymentResult
 * @param {PaymentResultProps}
 * @returns {<PaymentResult />}
*/
const PaymentResult = ({ isSuccessful = true, email, titleSuccess, titleError, highlightColor, textError }) => {
    return (react_1.default.createElement("div", { className: "payment-result-container", "data-testid": "payment-result-element" },
        react_1.default.createElement("div", { className: "result-container" },
            react_1.default.createElement("img", { src: isSuccessful ? payment_success_svg_1.default : payment_error_svg_1.default, alt: "", className: isSuccessful ? "success" : "error" })),
        react_1.default.createElement("div", { className: "text-container" },
            react_1.default.createElement("div", { className: "final-title" },
                react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                        __html: isSuccessful ? (titleSuccess || "") : (titleError || ""),
                    } })),
            isSuccessful ? (react_1.default.createElement("div", { className: "final-subtitle" },
                react_1.default.createElement("span", null, lang.gratitude))) : null,
            react_1.default.createElement("div", { className: "final-text" }, isSuccessful ? (react_1.default.createElement("span", null,
                lang.sentDocumentationTo,
                react_1.default.createElement("br", null),
                react_1.default.createElement("p", { "data-testid": "test-element-color", style: { color: highlightColor, fontFamily: "DIN Bold" }, className: "text-email" }, email))) : (react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                    __html: textError || "",
                } }))))));
};
exports.PaymentResult = PaymentResult;
//# sourceMappingURL=payment-result.js.map